import { render, staticRenderFns } from "./SupergroupForm.vue?vue&type=template&id=796f7c76&scoped=true"
import script from "./SupergroupForm.vue?vue&type=script&lang=js"
export * from "./SupergroupForm.vue?vue&type=script&lang=js"
import style0 from "./SupergroupForm.vue?vue&type=style&index=0&id=796f7c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f7c76",
  null
  
)

export default component.exports